import { render, staticRenderFns } from "./PartsInventory.vue?vue&type=template&id=5b2a325f"
import script from "./PartsInventory.vue?vue&type=script&lang=js"
export * from "./PartsInventory.vue?vue&type=script&lang=js"
import style0 from "./PartsInventory.vue?vue&type=style&index=0&id=5b2a325f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports